import { LogOperationsEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
@Entity("assigned_stock_log")

export class AssignedStockLog {

    @PrimaryGeneratedColumn("increment", { name: 'asssigned_stock_log_id' })
    assignedStockLogId: number;

    @Column("int", {
        nullable: false,
        name: "unit_id"
    })
    unitId: number;

    @Column("decimal", {
        nullable: false,
        name: "deassigned_quantity",
        precision: 10, scale: 3,
        unsigned: true,
        default: 0
    })
    deAssignedQuantity: number;

    @Column("decimal", {
        nullable: false,
        name: "assigned_quantity",
        precision: 10, scale: 3,
        unsigned: true,
        default: 0
    })
    assignedQuantity: number;
    @Column("decimal", {
        nullable: false,
        name: "transferred_quantity",
        precision: 10, scale: 3,
        unsigned: true,
        default: 0
    })
    transferredQuantity: number;

    @Column("int", {
        nullable: true,
        name: "saleorder_id"
    })
    saleOrderId: number;
      
    @Column("int", {
        nullable: false,
        name: "item_id"
    })
    itemId: number;

     @Column("int", {
        nullable: false,
        name: "packing_material_id"
    })
    packingMaterialId: number;

    @Column("enum", {
        nullable: true,
        name: "operation_type",
        enum: LogOperationsEnum,
    })
    operationType: LogOperationsEnum;
    
    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        default: 'Admin',
        name: "created_user"
    })
    createdUser: string | null;

   

    

}
